import { useState } from 'react';
import { Bot, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarSeparator,
} from '@/components/ui/sidebar';
import { Button } from '@/components/ui/button';
import ConversationList from '@/components/sidebar/ConversationList';
import SettingsPanel from '@/components/settings/SettingsPanel';

export default function ChatSidebar() {
  const { t } = useTranslation('chat');
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <>
      <Sidebar>
        <SidebarHeader className="p-4">
          <div className="flex items-center gap-2">
            <div className="flex size-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
              <Bot className="size-4" />
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold">Zehn AI</span>
              <span className="text-xs text-muted-foreground">{t('subtitle', 'AI-powered assistant')}</span>
            </div>
          </div>
        </SidebarHeader>
        <SidebarSeparator />
        <SidebarContent>
          <ConversationList />
        </SidebarContent>
        <SidebarSeparator />
        <SidebarFooter className="p-2">
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start gap-2 text-muted-foreground"
            onClick={() => setSettingsOpen(true)}
          >
            <Settings className="size-4" />
            <span className="text-xs">{t('settings', 'Settings')}</span>
          </Button>
        </SidebarFooter>
      </Sidebar>

      <SettingsPanel open={settingsOpen} onOpenChange={setSettingsOpen} />
    </>
  );
}
